const scrollMarkerBlocks = document.querySelectorAll(
	'.block-scroll-marker-text-rows'
);

const scrollMarkerBlockInstances = [];
let scrollMarkerTicking = false;

const initializeScrollMarkerBlocks = () => {
	if (scrollMarkerBlocks.length) {
		scrollMarkerBlocks.forEach((block) => {
			const rows = block.querySelector('.block-scroll-marker-rows');
			const activeMarker = block.querySelector(
				'.block-scroll-marker-rows__active-marker'
			);
			const endMarkers = block.querySelectorAll(
				'.block-scroll-marker-row__marker'
			);

			// Need all of these elements to proceed
			if (!activeMarker || !endMarkers || !rows) return;

			const endMarker = endMarkers[endMarkers.length - 1];

			// TODO: Need to update the activeMarkerOriginalTop and activeMarkerLeft on resize

			scrollMarkerBlockInstances.push({
				block,
				rows,
				rowsOriginalTop: rows.getBoundingClientRect().top,
				activeMarker,
				activeMarkerOriginalTop:
					activeMarker.getBoundingClientRect().top,
				activeMarkerLeft: activeMarker.getBoundingClientRect().left,
				endMarker,
				endMarkerTopOffset:
					endMarker.getBoundingClientRect().top -
					rows.getBoundingClientRect().top,
			});
		});

		window.addEventListener('scroll', () => {
			if (!scrollMarkerTicking) {
				window.requestAnimationFrame(scrollMarkerUpdatePosition);
				scrollMarkerTicking = true;
			}
		});
	}
};

const scrollMarkerUpdatePosition = () => {
	scrollMarkerBlockInstances.forEach((instance) => {
		const {
			block,
			rows,
			rowsOriginalTop,
			activeMarker,
			activeMarkerOriginalTop,
			activeMarkerLeft,
			endMarker,
			endMarkerTopOffset,
		} = instance;

		const isPastStart = activeMarkerOriginalTop - window.scrollY <= 160;
		const isBeforeEnd = endMarker.getBoundingClientRect().top > 160;
		const isPastEnd = endMarker.getBoundingClientRect().top <= 160;
		const isFixed = activeMarker.classList.contains('is-fixed');
		const isEnd = activeMarker.classList.contains('is-end');

		if (isPastStart && isBeforeEnd && (!isFixed || isEnd)) {
			// Make active marker fixed to follow scroll
			activeMarker.classList.add('is-fixed');
			activeMarker.classList.remove('is-end');
			activeMarker.style.left = activeMarkerLeft + 'px';
			activeMarker.style.top = '';
		} else if (isPastEnd && !isEnd) {
			// Make marker absolute and positioned over the endMarker when scrolling past the end
			activeMarker.classList.remove('is-fixed');
			activeMarker.classList.add('is-end');
			activeMarker.style.top = endMarkerTopOffset + 'px';
			activeMarker.style.left = '';
		} else if (!isPastStart) {
			activeMarker.classList.remove('is-fixed', 'is-end');
			activeMarker.style.left = '';
			activeMarker.style.top = '';
		}
	});
	scrollMarkerTicking = false;
};

initializeScrollMarkerBlocks();
